/* eslint-disable no-restricted-syntax */
import * as React from 'react'
import {
	CircularProgress,
	Divider,
	Tooltip,
} from '@mui/material'
import {
} from '@mui/icons-material'

import { useParams } from 'react-router'
import { StatusChip } from '../active-integration'
import { formatDate } from '../../utils'
import { useGetFeedQuery } from '../../graphql'
import { getHelpUrl, T3_AEMP_TRACKER_ASSET_ASSIGNMENT_KEY } from '../../utils/urls'
import { StatusDetails } from './status-details'
import {
	CardContainer,
	ChipContainer,
	DetailsContainer,
	TooltipIcon,
	UpdateContainer,
	UpdateTypography,
} from './status-card.styles'
import { StatusUpdateText } from './status-update-text'

type StatusCardProps = {
	onLinkClick?: ( title: string ) => void,
	shouldShowDates?: boolean,
}

export const StatusCard: React.FC<StatusCardProps> = ( {
	onLinkClick,
	shouldShowDates = true,
} ) => {
	const { id } = useParams<{ id: string }>()
	const { data: feed, isLoading: isLoadingFeed } = useGetFeedQuery( { feedId: id ?? '' }, {
		refetchInterval: 30000, // 30 seconds
	} )
	const { currentStatus, lastUpdate, nextUpdate, integration } = feed?.feed?.feed ?? {}

	const refreshInterval = integration?.refreshIntervalMinutes
	const trackerAssignmentHelpURL = getHelpUrl( T3_AEMP_TRACKER_ASSET_ASSIGNMENT_KEY, integration?.helpUrls )
	const feedName = feed?.feed?.feed?.name ?? ''

	const renderDatesSection = () => {
		if ( !shouldShowDates ) {
			return null
		}

		return ( <>
			<UpdateContainer>
				{ !isLoadingFeed && ( <>
					<UpdateTypography>
						<b>Last Update:</b>&nbsp;{formatDate( lastUpdate, '--' )}
					</UpdateTypography>
					<UpdateTypography variant={'body2'}>
						<StatusUpdateText status={currentStatus ?? 0} time={nextUpdate} refreshInterval={refreshInterval} />
						<Tooltip
							title={
								refreshInterval ? `Feed updates every ${refreshInterval} minutes.` : 'Feeds typically update every 15-60 minutes.'
							}
							arrow
							placement="top"
						>
							<TooltipIcon />
						</Tooltip>
					</UpdateTypography>
				</> )}
			</UpdateContainer>
			<Divider orientation={'vertical'} flexItem />
		</> )
	}

	return (
		<CardContainer>
			<ChipContainer>
				{ isLoadingFeed ? <CircularProgress size={24} /> : <StatusChip status={currentStatus ?? 0} /> }
			</ChipContainer>
			<Divider orientation={'vertical'} flexItem />
			{ renderDatesSection() }
			<DetailsContainer>
				{ !isLoadingFeed && ( <StatusDetails status={currentStatus ?? 0} onLinkClick={onLinkClick} trackerAssignmentHelpURL={trackerAssignmentHelpURL} name={feedName} /> )}
			</DetailsContainer>
		</CardContainer>
	)
}
